import apiClient from './client';
import { NewsCategory } from '@/types';

export interface NewsCategoryListResponse {
  data: NewsCategory[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
}

export const newsCategoryApi = {
  getAll: async (params: { page?: number; limit?: number; active?: boolean } = {}): Promise<NewsCategoryListResponse> => {
    const response = await apiClient.get('/api/news-categories', { params });
    return response.data;
  },

  create: async (data: Partial<NewsCategory>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/news-categories', data);
    return response.data;
  },

  update: async (id: number, data: Partial<NewsCategory>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/news-categories/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/news-categories/${id}`);
    return response.data;
  },
};
